import "#legacy/shared/components/wizard_modal.js";

window.SingleFormModal = function (trigger, header, body, modalClass) {
  var singleFormModalTrigger = jQuery(trigger);
  var singleFormModal = new WizardModal({ completeText: "OK" });

  singleFormModal.addPage({
    header: header,
    body: body,
  });

  // BEHAVIOUR

  singleFormModalTrigger.on("click", function (e) {
    e.preventDefault();
    singleFormModal.show();
  });

  jQuery(singleFormModal).on("beforeComplete", function () {
    singleFormModal.container.find("form").trigger("submit");
  });

  Form.decorate(singleFormModal.container);
  singleFormModal.container.addClass(modalClass); // TODO: Find a better way to add classes to modals

  return singleFormModal;
};
